import { create } from 'zustand';

type SidebarOverlayCommand = {
  id: number;
  open: boolean;
};

type OnboardingUiState = {
  tourRequestId: number;
  helpRequestId: number;
  isWelcomeModalOpen: boolean;
  sidebarOverlayCommand: SidebarOverlayCommand;
  requestTour: () => void;
  requestHelp: () => void;
  setWelcomeModalOpen: (open: boolean) => void;
  setSidebarOverlayOpen: (open: boolean) => void;
};

export const useOnboardingStore = create<OnboardingUiState>((set) => ({
  tourRequestId: 0,
  helpRequestId: 0,
  isWelcomeModalOpen: false,
  sidebarOverlayCommand: { id: 0, open: false },
  requestTour: () => set((state) => ({ tourRequestId: state.tourRequestId + 1 })),
  requestHelp: () => set((state) => ({ helpRequestId: state.helpRequestId + 1 })),
  setWelcomeModalOpen: (open) => set({ isWelcomeModalOpen: open }),
  setSidebarOverlayOpen: (open) => set((state) => ({
    sidebarOverlayCommand: {
      id: state.sidebarOverlayCommand.id + 1,
      open,
    },
  })),
}));
